import {Component, inject, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'core-plan-widget',
  imports: [],
  templateUrl: './plan-widget.html',
  styleUrl: './plan-widget.scss',
  host: {
    style: 'display: inline-flex;height: 100%;width: 100%;padding: 1.5rem 1rem;flex-direction: column;justify-content:space-between; gap: 2rem;'
  }
})
export class PlanWidget {

  private router = inject(Router);

  @Input()
  daysRemaining: number | null = null;
  @Input()
  planName: string = 'Plan Actual';

  goToPlan() {
    this.router.navigate(['/dashboard/plan'], {
      queryParamsHandling: 'preserve'
    });
  }
}
